import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/components/base.component';
import { BottomSheetComponent } from 'src/app/modules/projeto-completo/consulta-geral/bottom-sheet/bottom-sheet.component';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';

@Component({
  selector: 'app-processo-layout',
  templateUrl: './processo-layout.component.html',
  styleUrls: ['./processo-layout.component.scss']
})
export class ProcessoLayoutComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {

  id: number;
  menu: any[];
  pathRoute: string;
  menuActive: boolean;
  audit: AtualizacoesAudit;

  @ViewChild('menuDesktop') menuDesktop: ElementRef;
  @ViewChild('menuMobile') menuMobile: ElementRef;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
  ) {
    super()
  }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.params?.id;
    this.audit = {
      process_id: this.id,
    };
    this.initMenu();
  }

  ngAfterViewInit(): void {
    this.verificarOverflow();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initMenu(path = null) {
    this.pathRoute = path ? path : "/pre-projeto/processos/" + this.id + "/";
    this.menu = [
      {
        label: 'Cadastro',
        rota: 'cadastro',
        active: true,
      },
      {
        label: 'Abas',
        rota: 'abas',
        active: true,
      },
      {
        label: 'Grupos',
        rota: 'grupos',
        active: true,
      },
      {
        label: 'Questões',
        rota: 'questoes',
        active: true,
      },
    ];
  }

  isActive(route: string): boolean {
    return this.router.routerState.snapshot.url.includes(route);
  }

  openBottomSheet(): void {
    this._bottomSheet.open(BottomSheetComponent, { data: { pathRoute: this.pathRoute, menu: this.menu, type: 'processo' } });
  }

  verificarOverflow(): void {
    const menuDesktop = this.menuDesktop.nativeElement;
    const menuMobile = this.menuMobile.nativeElement;
    if (menuDesktop.offsetHeight > 70) {
      menuDesktop.classList.add('menu-desktop-none');
      menuMobile.classList.add('menu-mobile-active');
    } else {
      menuMobile.classList.remove('menu-mobile-active');
      menuDesktop.classList.remove('menu-desktop-none');
    }
  }
}